export default __webpack_public_path__ + "static/media/asset-5.7882d514.webp";